import { _ as e } from "./index.es461.js";
var r = e, a = r(Object.keys, Object), t = a;
export {
  t as _
};
//# sourceMappingURL=index.es466.js.map
